

import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Signphoto from "../../assets/images/logo.png";
import { userList } from "../../constants";
import GoogleLogin from "react-google-login"; 
import { gsap } from "gsap";
import 'font-awesome/css/font-awesome.min.css'; 
import './Signin.css';

const SignIn = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errEmail, setErrEmail] = useState("");
  const [errPassword, setErrPassword] = useState("");
  const [successMsg, setSuccessMsg] = useState("");

  useEffect(() => {
    // Animate the left section 
    gsap.fromTo(
      ".left-section",
      { opacity: 0, x: -50 }, // Start slightly to the left
      { opacity: 1, x: 0, duration: 1, ease: "power2.out" } // Slide into position
    );
  }, []);

  const handleEmail = (e) => {
    setEmail(e.target.value);
    setErrEmail("");
  };

  const handlePassword = (e) => {
    setPassword(e.target.value);
    setErrPassword("");
  };

  const handleSignIn = (e) => {
    e.preventDefault();

    // Clear previous error messages
    setErrEmail("");
    setErrPassword("");

    // Validate inputs
    let formIsValid = true;
    if (!email) {
      setErrEmail("Enter your email");
      formIsValid = false;
    }
    if (!password) {
      setErrPassword("Create a password");
      formIsValid = false;
    }

    if (!formIsValid) {
      return; // Stop the form submission if there are errors
    }

    const storedUsers = JSON.parse(localStorage.getItem("user"));
    if (storedUsers) {
      try {
        let usersArray = Array.isArray(storedUsers)
          ? [...userList, ...storedUsers]
          : [...userList, storedUsers];
        const user = usersArray.find((user) => user.email === email && user.password === password);

        if (user) {
          localStorage.setItem("loggedInUser", JSON.stringify(user));
          navigate("/");
        } else {
          console.log("User not found!");
        }
      } catch (error) {
        console.error("Error parsing stored user:", error);
      }
    } else {
      const user = userList.find(
        (user) => user.email === email && user.password === password
      );
      if (user) {
        localStorage.setItem("loggedInUser", JSON.stringify(user));
        navigate("/");
      } else {
        console.log("User not found!");
      }
    }
  };

  const handleGoogleLogin = (response) => {
    if (response?.profileObj) {
      const googleUser = response.profileObj;
      localStorage.setItem("loggedInUser", JSON.stringify(googleUser));
      navigate("/");
    }
  };

  return (
    <div className="w-full h-screen flex items-center justify-center" style={{ backgroundColor: "#fdfaf4" }}>
      {/* Left Section */}
      <div className="w-1/3 hidden lgl:inline-flex h-full text-white relative left-section">
        <div
          className="w-[550px] h-full px-10 flex flex-col items-center justify-center relative"
          style={{ backgroundColor: "#E6C78A" }}
        >
          <div
            className="w-[350px] h-[450px] flex justify-center items-center rounded-3xl mb-6 relative moving-section"
            style={{ backgroundColor: "#46A29F" }}
          >
            <div className="absolute top-20 left-64 flex flex-col items-center justify-center text-center z-0">
              <h1
                className="font-titleFont text-5xl font-medium mb-2 opacity-95"
                style={{
                  color: "white",
                  textShadow: "4px 6px 10px rgba(0, 0, 0, 0.4)",
                }}
              >
                Unlock The Secrets Of Egypt!
              </h1>
            </div>
            <div className="absolute bottom-0 right-10 flex flex-col items-center justify-center text-center z-50">
              <Link to="/">
                <img
                  src={Signphoto}
                  alt="logoImg"
                  className="w-70 h-70 object-contain"
                />
              </Link>
            </div>
          </div>
        </div>
      </div>
      {/* Right Section */}
      <div className="w-full lgl:w-1/2 h-full flex items-center justify-center">
        {successMsg ? (
          <div className="w-full lgl:w-[500px] h-full flex flex-col justify-center">
            <p className="w-full px-4 py-10 text-green-500 font-medium font-titleFont">
              {successMsg}
            </p>
            <Link to="/signup">
              <button className="w-full h-10 bg-primeColor text-gray-200 rounded-md text-base font-titleFont font-semibold tracking-wide hover:bg-black hover:text-white duration-300">
                Sign Up
              </button>
            </Link>
          </div>
        ) : (
          <form className="w-full lgl:w-[450px] h-screen flex items-center justify-center">
            <div className="px-6 py-4 w-full h-[90%] flex flex-col justify-center overflow-y-scroll scrollbar-thin scrollbar-thumb-primeColor">
              <h1 className="font-titleFont decoration-[1px] font-semibold text-3xl mdl:text-4xl mb-4 ml-36" style={{ fontFamily: 'Poppins, sans-serif' }}>
                LOGIN
              </h1>

              <div className="flex flex-col gap-3">
                <div className="flex flex-col gap-.5">
                  <p className="font-titleFont text-base font-semibold text-black">Username or Email</p>
                  <div className="relative">
                    <i className="fa fa-user absolute left-3 top-2 text-black" style={{ color: '#46A29F' }}></i>
                    <input
                      onChange={handleEmail}
                      value={email}
                      className="w-full h-8 pl-10 placeholder-black placeholder:text-sm placeholder:tracking-wide px-4 text-base font-medium placeholder:font-normal rounded-md border-[1px] outline-none"
                      style={{ backgroundColor: '#e4d1aee0', color: 'black' }}
                      type="email"
                      placeholder="User_Name or User@gmail.com"
                    />
                  </div>
                  {errEmail && (
                    <p className="text-sm text-red-500 font-titleFont font-semibold px-4">
                      <span className="font-bold italic mr-1">!</span>
                      {errEmail}
                    </p>
                  )}
                </div>

                <div className="flex flex-col gap-.5">
                  <p className="font-titleFont text-base font-semibold text-black">Password</p>
                  <div className="relative">
                    <i className="fa fa-lock absolute left-3 top-2 text-black" style={{ color: '#46A29F' }}></i>
                    <input
                      onChange={handlePassword}
                      value={password}
                      className="w-full h-8 pl-10 placeholder-black  placeholder:text-sm placeholder:tracking-wide px-4 text-base font-medium placeholder:font-normal rounded-md border-[1px] outline-none"
                      style={{ backgroundColor: '#e4d1aee0', color: 'black' }}
                      type="password"
                      placeholder="password"
                    />
                  </div>
                  {errPassword && (
                    <p className="text-sm text-red-500 font-titleFont font-semibold px-4">
                      <span className="font-bold italic mr-1">!</span>
                      {errPassword}
                    </p>
                  )}
                </div>

                <button onClick={handleSignIn} className="bg-gradient-to-r from-[#A79277] to-[#E6C78A] hover:bg-black text-white hover:text-white cursor-pointer w-full text-base font-medium h-10 rounded-md duration-300">
                  Login Now
                </button>

                <p className="text-sm text-center font-titleFont font-medium">
                  Don't have an Account?{" "}
                  <Link to="/signup">
                    <span className="text-black hover:text-transparent hover:bg-gradient-to-r hover:from-[#A79277] hover:to-[#5F4C34] bg-clip-text cursor-pointer duration-300">
                      Sign up
                    </span>
                  </Link>
                </p>
                <p className="text-sm text-center font-titleFont font-medium">
                  <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#A79277] to-[#5F4C34] cursor-pointer duration-300">
                    ـــــــــــــ OR ـــــــــــــ
                  </span>
                </p>

                {/* Google Login Button */}
                <div className="flex justify-center mt-4">
                  <GoogleLogin
                    clientId="YOUR_GOOGLE_CLIENT_ID"
                    onSuccess={handleGoogleLogin}
                    onFailure={(error) => console.log(error)}
                    buttonText="Login with Google"
                    className="google-login-button"
                  />
                </div>
              </div>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default SignIn;
